import { isUndefined, pick } from 'lodash'

export const transformDishToUpdateArgs = values =>
  pick(
    {
      ...values,
      ...(!isUndefined(values.courseType) && {
        courseTypeId: values.courseType,
      }),
      ...(!isUndefined(values.dishType) && {
        dishTypeId: values.dishType,
      }),
      ...(!isUndefined(values.diets) && {
        dietIds: values.diets,
      }),
      ...(!isUndefined(values.allergens) && {
        allergenIds: values.allergens,
      }),
      ...(!isUndefined(values.mainIngredients) && {
        mainIngredientsIds: values.mainIngredients,
      }),
      ...(!isUndefined(values.additionalIngredients) && {
        additionalIngredientsIds: values.additionalIngredients,
      }),
      ...(!isUndefined(values.choiceIngredients) && {
        choiceIngredientsIds: values.choiceIngredients,
      }),
    },
    [
      'styledName',
      'styledDescription',
      'styledIngredients',
      'courseTypeId',
      'dishTypeId',
      'dietIds',
      'allergenIds',
      'mainIngredientsIds',
      'additionalIngredientsIds',
      'choiceIngredientsIds',
      'lowPrice',
      'highPrice',
    ],
  )

export const transformDishAiResponseAndManualChangesToUpdateArgs = (
  aiResponse,
  manualChanges,
) => ({
  ...pick(aiResponse, [
    'dishTypeSuggestions',
    'courseTypeSuggestions',
    'miscAndChoiceSuggestions',
    'labelSuggestions',
    'ingredientSuggestions',
  ]),
  manualChanges: pick(
    {
      ...manualChanges,
      ...(!isUndefined(manualChanges.diets) && {
        dietIds: manualChanges.diets,
      }),
    },
    [
      'name',
      'description',
      'ingredients',
      'styledName',
      'styledDescription',
      'styledIngredients',
      'dishTypeId',
      'dietIds',
    ],
  ),
})
